import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useExamScoreStyle from "./styles";
import SidePannel from "./SidePannel";
import sidePannelData from "./sidePannelData";
import MyExam from "./ViewExam/Exam";
import Header from "./header";
import { useProfile } from "../../context/ProfileContext";
import { Typography } from "@mui/material";

function DashboardMain() {
  const classes = useExamScoreStyle();
  const location = useLocation();
  const currentRoute = location.pathname;

  const [header, setHeader] = useState(sidePannelData);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const { profile, fetchProfileData } = useProfile();

  const user = {
    image: profile?.image_url || "N/A",
    rollNumber: profile?.learner_information?.roll_number || null,
    full_name: profile?.full_name || null,
  };

  const handleMenuCollapse = () => {
    setMenuCollapse(!menuCollapse);
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  // Function to render content based on current route
  const renderContent = () => {
    switch (currentRoute) {
      case "/myexam":
        return <MyExam />;
      default:
        return <div>404 - Page Not Found</div>; // optional fallback
    }
  };

  return (
    <div className={`${classes.dflex} ${classes.w100}`}>
      {/* <div
        className={`${menuCollapse ? classes.w5 : classes.w20} ${classes.shadowright}`}
      >
        <SidePannel
          menuCollapse={menuCollapse}
          header={header}
        />
      </div> */}

      <div
        className={`${menuCollapse ? classes.w100 : classes.w100} ${
          classes.h100vh
        }`}
      >
        <div className={classes.header}>
          <Header
            handleMenuCollapse={handleMenuCollapse}
            menuCollapse={menuCollapse}
          />
          <div
            className={`${classes.w75} ${classes.h50}`}
            style={{ margin: "auto", paddingTop: "20px" }}
          >
            <div
              className={`${classes.w85} ${classes.dflex} ${classes.justifyspacebetween}`}
              style={{ margin: "auto" }}
            >
              <div style={{ width: "50%" }}>
                <div>
                  <Typography variant="h6">Welcome</Typography>
                  <Typography variant="h6">
                    <strong>{user.full_name}</strong>
                  </Typography>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <Typography variant="h6">IBT ID</Typography>
                  {/* <Typography variant="h6">SG ID</Typography> */}
                  <Typography variant="h6">
                    <strong>{user.rollNumber}</strong>
                  </Typography>
                </div>
              </div>
              <div style={{ backgroundColor: "#E0E0E2", borderRadius: "10px" }}>
                <img
                  src={user.image}
                  alt="Profile IMG"
                  // className={classes.profileImage}
                  style={{ width: "150px" }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "userAvatar.png";
                  }}
                />
              </div>
            </div>
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardMain;
